/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable function-paren-newline */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable no-use-before-define */
/* eslint-disable react/void-dom-elements-no-children */
import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import InputMultiSelectComponent from "../../../shared/components/forms/multi-select/multi-select-input";
import Navbar from "../../../shared/components/navbar";
import Sidebar from "../../../shared/components/sidebar";
import {
  DetailsTenantProps,
  updateTenantObj,
} from "../../../shared/interfaces/components/detailsTenant.interface";
import { SelectOptions } from "../../../shared/interfaces/components/form.interface";
import { User } from "../../../shared/interfaces/model/user.interface";
import * as actionDeatilTenant from "../../../store/tenant/action";
import { updateUserRowRequest } from "../../../store/tenant/action";
import * as actionTenantList from "../../../store/tenantUserList/action";
import Card from "../../card/pages/card";
import { Product } from "../../../shared/interfaces/model/product.interface";
import { PaidProductDetails, Tenant } from "../../../shared/interfaces/model/tenant.interface";
import Modal from "../../../shared/components/modal/modal";
import MainLayout from "../../../shared/components/MainLayout";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarClock, ChevronRight, Edit3, KeyRound, MailIcon, MapIcon, MapPin, MapPinHouse, Package, PackageSearch, PhoneCall, User2, User2Icon, UserCog, UserRound, Users, X } from "lucide-react";

type ProductMemberDetailsProps = {
  tenant: Tenant;
  currentProduct: PaidProductDetails;
  userList: User[];
}

const styles = {
  container: "min-h-screen bg-slate-50 dark:bg-slate-900",
  contentWrapper: "container mx-auto px-4 py-8 md:px-6 lg:px-8",
  inputBase: `w-full px-4 py-3.5 rounded-xl border bg-white/50 dark:bg-slate-800/50 
    backdrop-blur-sm focus:ring-2 focus:ring-sky-500 focus:border-transparent 
    transition-all duration-300 placeholder-slate-400 text-slate-600 dark:text-slate-200`,
  inputDisabled: "cursor-not-allowed border-slate-200 dark:border-slate-700/50 bg-slate-300",
  inputEnabled: "border-sky-300 hover:border-sky-400",
  sectionTitle: "text-2xl font-bold mb-6 flex items-center",
  iconWrapper: "p-2.5 rounded-xl bg-gradient-to-br from-sky-500/20 to-fuchsia-500/20 mr-3",
  icon: "w-6 h-6 text-sky-600 dark:text-sky-400",
  label: "text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center gap-2 mb-2",
  productButton: `py-3 px-5 flex justify-between items-center rounded-xl transition-all duration-300
    border border-sky-200 dark:border-sky-800 hover:bg-sky-50 dark:hover:bg-sky-900/30 w-full`,
  productButtonActive: "bg-sky-50 dark:bg-sky-900/30 border-sky-400 w-full",
  productDetails: `animate-fadeIn grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 gap-6 p-6 rounded-xl 
    bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm border border-sky-200 dark:border-sky-800`,
  gradientText: "bg-clip-text text-transparent bg-gradient-to-r from-sky-600 to-fuchsia-600",
};

const animations = {
  container: {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        duration: 0.3,
      },
    },
  },
  item: {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  },
};


export const UserProfile = (props: DetailsTenantProps) => {
  const dispatch = useDispatch();
  const searchLoc = useLocation().search;
  const tenantId = new URLSearchParams(searchLoc).get("tenantId") ?? "";

  // hook state
  const [tenId, setTenId] = useState(
    window.localStorage.getItem("tenantId") ?? tenantId ?? ""
  );

  const [activeTab, setActiveTab] = useState(0);
  const [product, setProduct] = useState([] as SelectOptions[]);
  const [productString, setProductString] = useState([] as string[]);
  const [products, setProducts] = useState([] as SelectOptions[]);

  const [disabled, setDisabled] = useState(false);
  // destructured reducer state
  const { tenant, detailsTenantIsOk, userList, isUserListOk } = useSelector(
    (state: any) => ({
      tenant: state.tenantsReducer.detailsTenant,
      detailsTenantIsOk: state.tenantsReducer.detailsTenantIsOk,
      userList: state.tenantUserListReducer.tenantsUserList?.users,
      isUserListOk: state.tenantUserListReducer.isTenantsUserListOk,
    })
  );
  const [name, setName] = useState(tenant?.userData?.name);
  const [email, setEmail] = useState(tenant?.userData?.email);
  const [surname, setSurname] = useState(tenant?.userData?.surname);
  const [city, setCity] = useState(tenant?.userData?.city);
  const [dateOfBirth, setDateOfBirth] = useState(tenant?.userData?.dateOfBirth);
  const [province, setProvince] = useState(tenant?.userData?.province);
  const [fiscalCode, setFiscalCode] = useState(tenant?.userData?.fiscalCode);
  const [address, setAddress] = useState(tenant?.userData?.address);
  const [phoneNumber, setPhoneNumber] = useState(tenant?.userData?.phoneNumber);
  const allowedToEdit = false;

  const isUpdateModeOn: boolean =
    window?.localStorage?.getItem("isUpdateModeOn") === "true";
  const fadeIn = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -30 },
    transition: { duration: 0.3 },
  };
  React.useEffect(() => {
    const productList: SelectOptions[] = [];
    const productListString: string[] = [];
    const productsFromApi: SelectOptions[] = [];
    setTenId(tenId);
    if (isUpdateModeOn) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }

    if (!detailsTenantIsOk) {
      dispatch(actionDeatilTenant.getDetailsTenantRequest(tenId || ""));
    }

    if (tenId !== "") {
      dispatch(actionTenantList.getTenantUserListRequest(tenId || ""));
    } else {
      dispatch(actionTenantList.getTenantUserListRequest(tenId));
    }

    if (props.productList !== undefined && props.productList.length > 0) {
      props.productList.forEach((element: Product) => {
        productsFromApi.push({ id: element.appCode, value: element.name });
      });
      setProducts(productsFromApi);

      if (Array.isArray(tenant?.product)) {
        tenant.product.forEach((element: string) => {
          const selectedProduct = {
            ...productsFromApi.find((item) => item.id === element),
          };
          productList.push(selectedProduct as SelectOptions);
        });
        setProduct(productList);
        tenant.product.map((elem: string) => productListString.push(elem.toString()));
        setProductString(productListString);
      }
    }

    setName(tenant?.userData?.name);
    setEmail(tenant?.userData?.email);
    setSurname(tenant?.userData?.surname);
    setCity(tenant?.userData?.city);
    setDateOfBirth(tenant?.userData?.dateOfBirth);
    setProvince(tenant?.userData?.province);
    setFiscalCode(tenant?.userData?.fiscalCode);
    setAddress(tenant?.userData?.address);
    setPhoneNumber(tenant?.userData?.phoneNumber);

    // redirect to login page in case of error / missing permissions
    /* if (isUserListOk === false || detailsTenantIsOk === false) {
      props.location("/");
    } */
  }, [
    tenant,
    dispatch,
    props.tenantId,
    detailsTenantIsOk,
    props,
    isUserListOk,
    tenantId,
    tenId,
    isUpdateModeOn,
  ]);

  const nameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setName(data.target.value);
  };

  const emailChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(data.target.value);
  };

  const surnameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setSurname(data.target.value);
  };

  const cityChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setCity(data.target.value);
  };

  const dateOfBirthChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setDateOfBirth(data.target.value);
  };

  const provinceChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setProvince(data.target.value);
  };

  const fiscalCodeChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setFiscalCode(data.target.value);
  };

  const addressChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setAddress(data.target.value);
  };

  const phoneNumberChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setPhoneNumber(data.target.value);
  };

  const productsChange = (data: SelectOptions[]) => {
    if (data !== undefined) {
      const lista: string[] = [];
      data.map((item) => lista.push(item.id.toString()));
      setProductString(lista);
      setProduct(data);
    }
  };
  // get details tenant
  const getDetailTenant = (tenaId: string | undefined) => {
    setName(tenant?.userData?.name);
    setEmail(tenant?.userData?.email);
    setSurname(tenant?.userData?.surname);
    setCity(tenant?.userData?.city);
    setDateOfBirth(tenant?.userData?.dateOfBirth);
    setProvince(tenant?.userData?.province);
    setFiscalCode(tenant?.userData?.fiscalCode);
    setAddress(tenant?.userData?.address);
    setPhoneNumber(tenant?.userData?.phoneNumber);
    dispatch(actionDeatilTenant.getDetailsTenantRequest(tenId || ""));
    // setOrganizationName(tenant.organizationName);
  };

  const updateUserRow = (updateUserParam: updateTenantObj) => {
    if (updateUserParam) {
      dispatch(updateUserRowRequest(updateUserParam));
    }
  };

  const handleToggle = (index: number) => {
    setActiveTab((prev) => ((prev === index) ? -1 : index));
  };

  const fields = [{
    name: "Product",
    Icons: <PackageSearch className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />,
    id: "productAppName"
  },
  {
    name: "Number of employees",
    Icons: <Users className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />,
    id: "numberEmployees"
  },
  {
    name: "Subscription duration",
    Icons: <CalendarClock className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />,
    id: "payment"
  },
  {
    name: "Version",
    Icons: <Package className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />,
    id: "tier"
  }
  ];

  return (
    <MainLayout>
      <div className="">
        <div className="container p-2 md:p-10 sm:p-2 xs w-full">
          <div
            className="detailsTenant--wrapper col-xs-12 col-lg-12 py-10 sm:py-2 xs:py-2"
            data-test="detailsTenant-wrapper"
          >
            <p className="text-2xl font-bold mb-6 mt-8 flex items-center">
              <div className="p-2 rounded-lg bg-sky-100 dark:bg-sky-900/50 mr-2">
                <UserRound className="w-6 h-6 text-sky-600 dark:text-sky-400" />
              </div>
              {disabled ? "User Details" : "Edit User Details"}
            </p>


            {/* new ui setup */}

            <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mt-3">
              <div className="space-y-3">
                <div className="flex gap-6">
                  <div className="flex-1">
                    <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                      <UserRound className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                      Name:
                    </label>
                    <div className="group relative transition-all duration-300 mt-2">
                      <input
                        name="name"
                        className={`w-full pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled
                          ? "cursor-not-allowed border-slate-300 dark:border-slate-700"
                          : "border-green-300"
                          }`}
                        value={name}
                        disabled={disabled}
                        type="text"
                        id="signup-name"
                        onChange={nameChange}
                      />
                    </div>
                  </div>

                  <div className="flex-1">
                    <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                      <UserCog className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                      Surname:
                    </label>
                    <div className="group relative transition-all duration-300 mt-2">
                      <input
                        name="surname"
                        className={`w-full pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled
                          ? "cursor-not-allowed border-slate-300 dark:border-slate-700"
                          : "border-green-300"
                          }`}
                        value={surname}
                        disabled={disabled}
                        type="text"
                        id="surname"
                        onChange={surnameChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <section>
              {/* <div className="row">
                <div className="col-xs-6">
                  <InputFieldComponent
                    label="Nome:"
                    bold
                    data-test="name"
                    name="name"
                    id="signup-name"
                    type="text"
                    value={name}
                    title="Inserire campo"
                    disabled={disabled}
                    onChangeHandler={nameChange}
                  />
                </div>
                <div className="col-xs-6">
                  <InputFieldComponent
                    label="Cognome: "
                    bold
                    data-test="surname"
                    name="surname"
                    id="surname"
                    type="text"
                    value={surname}
                    title="Inserire campo"
                    disabled={disabled}
                    onChangeHandler={surnameChange}
                  />
                </div>
              </div> */}

              <p className="text-2xl font-bold my-8 flex items-center">
                <div className="p-2 rounded-lg bg-sky-100 dark:bg-sky-900/50 mr-2">
                  <PackageSearch className="w-6 h-6 text-sky-600 dark:text-sky-400" />
                </div>
                Products:
              </p>
              {/* <h1 className="text-lg font-bold">Prodotti:</h1> */}
              <motion.section className="mb-10"
                variants={animations.item}>

                {/* Product Buttons */}
                <div className="flex flex-wrap gap-4 mb-3  p-2">
                  {tenant?.testProducts?.map((pro: PaidProductDetails, index: number) => {
                    const isValid = pro.expireDate && new Date(pro.expireDate) > new Date();
                    return isValid && (
                      <motion.button
                        key={pro.productAppCode}
                        className={`${styles.productButton} ${activeTab === index ? styles.productButtonActive : ''
                          }`}
                        onClick={() => handleToggle(index)}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <span className="flex items-center gap-2">
                          <Package className="w-5 h-5 text-sky-500" />
                          {pro.productAppName}
                        </span>
                        <ChevronRight
                          className={`w-5 h-5 transition-transform duration-300 ${activeTab === index ? 'rotate-90' : ''
                            }`}
                        />
                      </motion.button>
                    );
                  })}
                  {/* Product Details */}
                  <AnimatePresence  >
                    <div className="w-full">
                      {tenant?.testProducts?.map((pro: PaidProductDetails, index: number) => (
                        activeTab === index && (
                          <motion.div
                            key={pro.productAppCode}
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.3 }}
                            className={styles.productDetails}
                          >
                            {fields.map((field) => (
                              <div key={field.id} className="space-y-2 ">
                                <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                                  {field.Icons}
                                  {field.name}
                                </label>
                                <input
                                  type="text"
                                  className={`${styles.inputBase} ${styles.inputDisabled}`}
                                  value={(pro[field.id as keyof Omit<PaidProductDetails, 'invoices'>] ?? '').toString()}
                                  disabled
                                  onChange={() => !allowedToEdit ? null : null}
                                />
                              </div>
                            ))}
                          </motion.div>
                        )
                      ))}
                    </div>
                  </AnimatePresence>
                </div>


              </motion.section>
            </section>

            {tenant && tenant.id && (
              <>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                  <div className="space-y-3">
                    <div className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-6">
                      <div className="flex-1">
                        <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                          <MailIcon className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                          Email:
                        </label>
                        <div className="group relative transition-all duration-300 mt-2">
                          <input
                            name="email"
                            className={`w-full pr-4 py-3 rounded-xl border  transition-all duration-200 ${styles.inputDisabled}`}
                            value={email}
                            disabled
                            type="text"
                            id="email"
                            onChange={() => !allowedToEdit ? null : emailChange}
                          />
                        </div>
                      </div>

                      <div className="flex-1">
                        <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                          <MapPin className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                          City:
                        </label>
                        <div className="group relative transition-all duration-300 mt-2">
                          <input
                            name="city"
                            className={`w-full pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled
                              ? "cursor-not-allowed border-slate-300 dark:border-slate-700"
                              : "border-green-300"
                              }`}
                            value={city}
                            disabled={disabled}
                            type="text"
                            id="signup-city"
                            onChange={cityChange}
                          />
                        </div>
                      </div>

                      <div className="flex-1">
                        <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                          <MapIcon className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                          Province:
                        </label>
                        <div className="group relative transition-all duration-300 mt-2">
                          <input
                            name="province"
                            className={`w-full pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled
                              ? "cursor-not-allowed border-slate-300 dark:border-slate-700"
                              : "border-green-300"
                              }`}
                            value={province}
                            disabled={disabled}
                            type="text"
                            id="signup-province"
                            onChange={provinceChange}
                          />
                        </div>
                      </div>

                      <div className="flex-1">
                        <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                          <CalendarClock className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                          Date of birth:
                        </label>
                        <div className="group relative transition-all duration-300 mt-2">
                          <input
                            name="date-of-birth"
                            className={`w-full pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled
                              ? "cursor-not-allowed border-slate-300 dark:border-slate-700"
                              : "border-green-300"
                              }`}
                            value={dateOfBirth}
                            disabled={disabled}
                            type="text"
                            id="signup-date-of-birth"
                            onChange={dateOfBirthChange}
                          />
                        </div>
                      </div>

                      <div className="flex-1">
                        <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                          <KeyRound className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                          Fiscal code:
                        </label>
                        <div className="group relative transition-all duration-300 mt-2">
                          <input
                            name="fiscal-code"
                            className={`w-full pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled
                              ? "cursor-not-allowed border-slate-300 dark:border-slate-700"
                              : "border-green-300"
                              }`}
                            value={fiscalCode}
                            disabled={disabled}
                            type="text"
                            id="signup-fiscal-code"
                            onChange={fiscalCodeChange}
                          />
                        </div>
                      </div>

                      <div className="flex-1">
                        <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                          <MapPinHouse className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                          Address:
                        </label>
                        <div className="group relative transition-all duration-300 mt-2">
                          <input
                            name="address"
                            className={`w-full pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled
                              ? "cursor-not-allowed border-slate-300 dark:border-slate-700"
                              : "border-green-300"
                              }`}
                            value={address}
                            disabled={disabled}
                            type="text"
                            id="signup-address"
                            onChange={addressChange}
                          />
                        </div>
                      </div>

                      <div className="flex-1">
                        <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center flex-row">
                          <PhoneCall className="w-6 h-6 text-[#153581] dark:text-[#153581] mr-2" />
                          Phone number:
                        </label>
                        <div className="group relative transition-all duration-300 mt-2">
                          <input
                            name="phone-numbe"
                            className={`w-full pr-4 py-3 rounded-xl border focus:ring-sky-500 focus:border-transparent transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled
                              ? "cursor-not-allowed border-slate-300 dark:border-slate-700"
                              : "border-green-300"
                              }`}
                            value={phoneNumber}
                            disabled={disabled}
                            type="text"
                            id="phone-number"
                            onChange={phoneNumberChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                {/* <div className="row">
                  <div className="flex justify-end"> 
                  <div className="detailsTenant">
                      <div className="row">
                        <div className="col-xs-6">
                          <InputFieldComponent
                            label="Email:"
                            bold
                            data-test="email"
                            name="email"
                            id="email"
                            type="text"
                            value={email}
                            title="Inserire campo"
                            disabled
                            onChangeHandler={emailChange}
                          />
                        </div>
                        <div className="col-xs-6">
                          <InputFieldComponent
                            label="Città:"
                            bold
                            data-test="city"
                            name="city"
                            id="signup-city"
                            type="text"
                            value={city}
                            title="Inserire campo"
                            disabled={disabled}
                            onChangeHandler={cityChange}
                          />
                        </div>
                        <div className="col-xs-6">
                          <InputFieldComponent
                            label="Provincia:"
                            bold
                            data-test="province"
                            name="province"
                            id="signup-province"
                            type="text"
                            value={province}
                            title="Inserire campo"
                            disabled={disabled}
                            onChangeHandler={provinceChange}
                          />
                        </div>

                        <div className="col-xs-6">
                          <InputFieldComponent
                            label="Data di nascita:"
                            bold
                            data-test="date-of-birth"
                            name="date-of-birth"
                            id="signup-date-of-birth"
                            type="text"
                            value={dateOfBirth}
                            title="Inserire campo"
                            disabled={disabled}
                            onChangeHandler={dateOfBirthChange}
                          />
                        </div>
                        <div className="col-xs-6">
                          <InputFieldComponent
                            label="Codice Fiscale:"
                            bold
                            data-test="fiscal-code"
                            name="fiscal-code"
                            id="signup-fiscal-code"
                            type="text"
                            value={fiscalCode}
                            title="Inserire campo"
                            disabled={disabled}
                            onChangeHandler={fiscalCodeChange}
                          />
                        </div>

                        <div className="col-xs-6">
                          <InputFieldComponent
                            label="Indirizzo:"
                            bold
                            data-test="address"
                            name="address"
                            id="signup-address"
                            type="text"
                            value={address}
                            title="Inserire campo"
                            disabled={disabled}
                            onChangeHandler={addressChange}
                          />
                        </div>

                        <div className="col-xs-6">
                          <InputFieldComponent
                            label="Numero di telefono:"
                            bold
                            data-test="phone-number"
                            name="phone-number"
                            id="phone-number"
                            type="text"
                            value={phoneNumber}
                            title="Inserire campo"
                            disabled={disabled}
                            onChangeHandler={phoneNumberChange}
                          />
                        </div>

                        <div className="col-xs-6" style={{ display: 'none' }}>
                          <InputMultiSelectComponent
                            label="Prodotti:"
                            bold
                            id="signup-product"
                            options={products}
                            value={product}
                            isSingleSelect={false}
                            placeholder="Seleziona un prodotto"
                            required
                            disabled
                            onMultiSelectChangeHandler={productsChange}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6" style={{ display: 'none' }}>
                          <InputFieldComponent
                            label="Numero di dipendenti:"
                            bold
                            data-test="number_employees"
                            name="number-employees"
                            id="number-employees"
                            type="text"
                            value={tenant.numberEmployees}
                            title="Inserire campo"
                            disabled
                          />
                        </div>
                        <div className="col-xs-6" style={{ display: 'none' }}>
                          <InputFieldComponent
                            label="Durata della sottoscrizione:"
                            bold
                            data-test="subscriptionDuration"
                            name="subscriptionDuration"
                            id="subscriptionDuration"
                            type="text"
                            value={tenant.subscriptionDuration}
                            title="Inserire campo"
                            disabled
                          />
                        </div>
                      </div>

                      <div className="row detailsTenant--underDetail">
                        <div className="col-xs-6" style={{ display: 'none' }}>
                          <InputFieldComponent
                            label="Versione: "
                            bold
                            data-test="tier"
                            name="tier"
                            id="tier"
                            type="text"
                            value={tenant.tier}
                            title="Inserire campo"
                            disabled
                          />
                        </div>
                      </div>
                    </div> 
                     <div>
                      {disabled && (
                        <Button
                          title=" EDIT PROFILE"
                          onClickHandler={() => setDisabled(!disabled)}
                        />
                      )}
                      <Link to="/private/tenantlist">
                        <Button
                          title="Indietro"
                          onClickHandler={() => setDisabled(!disabled)}
                        />
                      </Link>
                      {!disabled && (
                        <Button
                          title="SAVE EDIT"
                          onClickHandler={() => {
                            if (tenId) {
                              const upTenant = {
                                id: tenant.id,
                                newName: name,
                                newEmail: email,
                                newProduct: productString,
                                newSurname: surname,
                                newCity: city,
                                newProvince: province,
                                newDateOfBirth: dateOfBirth,
                                newAddress: address,
                                newFiscalCode: fiscalCode,
                                newPhoneNumber: phoneNumber
                              };
                              updateUserRow(upTenant);
                            }
                            setDisabled(!disabled);
                          }}
                        />
                      )}
                      {!disabled && (
                        <Button
                          title="CANCEL Modifica"
                          onClickHandler={() => {
                            getDetailTenant(tenId);
                            setDisabled(!disabled);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div> */}


                {/* new ui buttons */}
                <motion.div
                  className="flex flex-wrap gap-4 justify-end pt-6"
                  variants={fadeIn}
                >
                  {disabled ? (
                    <>
                      <button
                        onClick={() => setDisabled(false)}
                        className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-sky-600 to-sky-700 
                            text-white rounded-xl hover:from-sky-700 hover:to-sky-800 transition-all duration-200
                            shadow-lg shadow-sky-500/20 hover:shadow-sky-500/30"
                      >
                        <Edit3 className="w-4 h-4" />
                        Edit User Details
                      </button>
                      <Link to="/private/tenantlist">
                        <button
                          className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 
                            text-white rounded-xl hover:from-red-700 hover:to-red-800 transition-all duration-200
                            shadow-lg shadow-red-500/20 hover:shadow-red-500/30"
                        >
                          Back
                        </button>
                      </Link>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          if (tenId) {
                            const upTenant = {
                              id: tenant.id,
                              newName: name,
                              newEmail: email,
                              newProduct: productString,
                              newSurname: surname,
                              newCity: city,
                              newProvince: province,
                              newDateOfBirth: dateOfBirth,
                              newAddress: address,
                              newFiscalCode: fiscalCode,
                              newPhoneNumber: phoneNumber
                            };
                            updateUserRow(upTenant);
                          }
                          setDisabled(!disabled);
                        }}
                        className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 
                            text-white rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-200
                            shadow-lg shadow-green-500/20 hover:shadow-green-500/30"
                      >
                        Save Changes
                      </button>
                      <button
                        onClick={() => {
                          getDetailTenant(tenId);
                          setDisabled(!disabled);
                        }}
                        className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 
                            text-white rounded-xl hover:from-red-700 hover:to-red-800 transition-all duration-200
                            shadow-lg shadow-red-500/20 hover:shadow-red-500/30"
                      >
                        <X className="w-4 h-4" />
                        Cancel Changes
                      </button>
                    </>
                  )}
                </motion.div>

              </>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
